var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from '@headlessui/react';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../../../../store';
import { participantsSelector } from '../../../../../store/slices/participantSlice';
import sendAPIRequest from '../../../../../helpers/api/plugNmeetAPI';
import { CommonResponse, SwitchPresenterReq, SwitchPresenterTask, } from '../../../../../helpers/proto/plugnmeet_common_api_pb';
const SwitchPresenterMenuItem = ({ userId }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const { t } = useTranslation();
    const onClick = async () => {
        const body = new SwitchPresenterReq({
            userId: participant === null || participant === void 0 ? void 0 : participant.userId,
            task: (participant === null || participant === void 0 ? void 0 : participant.metadata.is_presenter)
                ? SwitchPresenterTask.DEMOTE
                : SwitchPresenterTask.PROMOTE,
        });
        const r = await sendAPIRequest('switchPresenter', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('left-panel.menus.notice.presenter-changed'), {
                toastId: 'lock-setting-status',
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                toastId: 'lock-setting-status',
                type: 'error',
            });
        }
    };
    const render = () => {
        return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("button", { className: "text-gray-900 dark:text-darkText group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs lg:text-sm transition ease-in hover:bg-primaryColor hover:text-white", onClick: () => onClick(), children: (participant === null || participant === void 0 ? void 0 : participant.metadata.is_presenter)
                        ? t('footer.icons.demote-presenter')
                        : t('footer.icons.promote-presenter') })) }) }));
    };
    return render();
};
_react_refresh_temp_1 = SwitchPresenterMenuItem;
$RefreshReg$(_react_refresh_temp_1, "SwitchPresenterMenuItem");
_react_refresh_temp_2(SwitchPresenterMenuItem, "HmaIZPzoIBnwbVSIcuvyGd1iwy8=", false, () => [useAppSelector, useTranslation]);
export default SwitchPresenterMenuItem;
